import gql from 'graphql-tag';

export default gql`
mutation UserApprove(
        $uuid: String!
      ) {
    userApprove(uuid: $uuid) {
      __typename
    }
}
`;
